const rules = {
  emailAddress: {
    required: true    
  },
}

export default rules;